function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useMemo, useState } from 'react';
import { Typography } from 'seagull';
import { WideArrowDownward, WideArrowUpward } from 'seagull/icons';
import { Collapse } from '@material-ui/core';
import { splitServices } from "./StatementOfWork.utils";
import styles from "./StatementOfWork.module.scss";
import AgreementServiceInstance from "./AgreementServiceInstance";
const toggleIconSize = 18;
export default function StatementOfWork(props) {
  const {
    services,
    isVendor
  } = props;
  const [activeServices, inactiveServices] = useMemo(() => splitServices(services, isVendor), [isVendor, services]);
  const [stoppedOrCompletedServicesShown, setStoppedOrCompletedServicesShown] = useState(activeServices.length === 0);
  return /*#__PURE__*/React.createElement("section", {
    className: styles.root
  }, activeServices.map((service, idx) => /*#__PURE__*/React.createElement(AgreementServiceInstance, _extends({
    key: service.id
  }, props, {
    service: service,
    idx: idx
  }))), inactiveServices.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: styles.stoppedOrCompletedServicesContainer
  }, /*#__PURE__*/React.createElement("button", {
    className: styles.header,
    "data-testid": "toggle-stopped-completed-services",
    onClick: () => setStoppedOrCompletedServicesShown(!stoppedOrCompletedServicesShown)
  }, /*#__PURE__*/React.createElement(Typography, null, "Stopped and completed services"), /*#__PURE__*/React.createElement(Typography, {
    skin: "secondary"
  }, stoppedOrCompletedServicesShown ? /*#__PURE__*/React.createElement(WideArrowUpward, {
    height: toggleIconSize,
    width: toggleIconSize
  }) : /*#__PURE__*/React.createElement(WideArrowDownward, {
    height: toggleIconSize,
    width: toggleIconSize
  }))), /*#__PURE__*/React.createElement(Collapse, {
    in: stoppedOrCompletedServicesShown
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.collapseContainer
  }, inactiveServices.map((service, idx) => /*#__PURE__*/React.createElement(AgreementServiceInstance, _extends({
    key: service.id
  }, props, {
    service: service,
    idx: activeServices.length + idx
  })))))));
}